import React, { Component } from 'react'
import { Form, Field } from 'react-final-form'
import {
  Button,
  Card,
  CardContent,
  FormFieldWrapper,
  FieldLabel,
  FinalInput,
  FieldError,
  FormActionsWrapper,
  FinalPasswordInput
} from '../Components'
import { HeadingPrimary } from '../Styles/Typography'
import { PageWrapper, FormWrapper } from './Styles'
import DevConfig from '../Config/DevConfig'
import API from '../Services/Api'

const api = API.create()

const validate = values => {
  const errors = {}
  if (!values.username) {
    errors.username = 'Required'
  }

  if (!values.password) {
    errors.password = 'Required'
  }
  return errors
}

const testUser = {
  username: 'pjhbdemo',
  password: 'plumbingdemo123'
}

const localStorage = window.localStorage

class LoginContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      error: null
    }
  }

  submit = async ({ username, password }) => {
    try {
      this.setState({ error: null })
      localStorage.removeItem('uid')
      const res = await api.login(username, password)
      const resData = res && res.data && res.data.qdbapi
      if (resData) {
        if (resData.errcode === '0') {
          localStorage.setItem('uid', resData.userid)
          this.props.history.push('/claim')
        } else {
          throw new Error(resData.errtext)
        }
      } else {
        throw new Error('Something went wrong.')
      }
    } catch ({ message }) {
      this.setState({ error: message })
    }
  }
  

  render () {
    const { error } = this.state
    return (
      <PageWrapper>
        <Card>
          <CardContent>
            <HeadingPrimary>Login</HeadingPrimary>
            {error && <FieldError>{error}</FieldError>}
            <FormWrapper>
              <Form
                validate={validate}
                onSubmit={this.submit}
                initialValues={DevConfig.__DEV__ ? testUser : {}}
              >
                {
                  ({ handleSubmit, submitting }) => (
                    <form onSubmit={handleSubmit}>
                      <FormFieldWrapper>
                        <FieldLabel>Username</FieldLabel>
                        <Field
                          name='username'
                          component={FinalInput}
                          type='text'
                        />
                      </FormFieldWrapper>
                      <FormFieldWrapper>
                        <FieldLabel>Password</FieldLabel>
                        <Field
                          name='password'
                          component={FinalPasswordInput}
                        />
                      </FormFieldWrapper>
                      <FormActionsWrapper>
                        <Button
                          type='submit'
                          processing={submitting}
                          fullWidth
                        >
                          Login
                        </Button>
                      </FormActionsWrapper>
                    </form>
                  )
                }
              </Form>
            </FormWrapper>
          </CardContent>
        </Card>
      </PageWrapper>
    )
  }
}

export default LoginContainer



// WEBPACK FOOTER //
// ./src/Containers/LoginContainer.jsx